import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApiRootService {
    constructor(
        @Inject(APP_BASE_HREF) private readonly _appBaseHref: string
    ) { }

    /**
     * Return the base url to use when making API calls.
     */
    public getApiRoot(): string {
        return this._appBaseHref;
    }
}
